export const preventDefault = (
  e: Pick<MouseEvent, 'stopPropagation' | 'preventDefault'>,
) => {
  e.stopPropagation();
  e.preventDefault();
};
